import { render, staticRenderFns } from "./Addresses.vue?vue&type=template&id=47e5c29b&scoped=true"
import script from "./Addresses.vue?vue&type=script&lang=js"
export * from "./Addresses.vue?vue&type=script&lang=js"
import style0 from "../styles/index.css?vue&type=style&index=0&id=47e5c29b&prod&scoped=true&lang=css&external"
import style1 from "../styles/addresses.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e5c29b",
  null
  
)

export default component.exports